import EmendasParlamentares from '@/views/admin/emendas-parlamentares/emendas'
import Vereadores from '@/views/admin/emendas-parlamentares/vereadores'
import SalvarVereador from '@/views/admin/emendas-parlamentares/vereadores/Save'
import SalvarEmenda from '@/views/admin/emendas-parlamentares/emendas/Save'
import ProcessosPagamento from '@/views/admin/emendas-parlamentares/processos-pagamento'
import SalvarProcessosPagamento from '@/views/admin/emendas-parlamentares/processos-pagamento/Save'
import ListarProcessosPagamento from '@/views/admin/emendas-parlamentares/emendas/ListProcessosPagamento'
import Remanejamento from '@/views/admin/emendas-parlamentares/emendas/Remanejamento'

export const emendasParlamentares = [
  {
    name: 'user_emendasparlamentares',
    path: 'emenda/list',
    component: EmendasParlamentares,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_vereadores',
    path: 'vereador/list',
    component: Vereadores,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_processospagamento',
    path: 'processospagamento/list',
    component: ProcessosPagamento,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_salvar_emenda',
    path: 'emenda/save/:id?',
    component: SalvarEmenda,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_salvar_vereador',
    path: 'vereador/save/:id?',
    component: SalvarVereador,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_salvar_processospagamento',
    path: 'processospagamento/save/:id?',
    component: SalvarProcessosPagamento,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_list_emenda_processos',
    path: 'emenda/list/:id?/processos',
    component: ListarProcessosPagamento,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_remanejamento',
    path: 'emenda/remanejamento',
    component: Remanejamento,
    props: true,
    meta: {
      requiresAuth: true,
      userAuth: true,
      title: 'Remanejamento'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/emendasParlamentares.js